<template>
  <b-overlay :show="busy" rounded="sm">
    <!-- {{ search }}<br /><br />
    {{ item }} -->
    <b-card class="standardpage reports invoices border-none">
      <!-- <b-card-header class="py-1 mb-2">
        <i :class="options.icon" class="text-primary mr-1"></i>
        {{ item.slac }}
        <span class="text-warning"
          >&lt;{{ selection.length == 0 ? "new" : "edit" }}&gt;</span
        >
      </b-card-header> -->
      <div class="availtable datatable text-left">
        <b-card-body class="py-0">
          <b-tabs class="gridtabs">
            <b-tab :active="true">
              <template #title>
                <div class="badgecontainer pr-5">
                  <i :class="options.icon" class="text-primary mr-1"></i>
                  <span class="text-center badgenormal badge-secondary badge-pill">
                    {{ item.initials }}
                  </span>
                  <span class="text-warning">&lt;{{ selection.length == 0 ? "new" : "edit" }}&gt;</span>
                </div>
              </template>
              <p class="py-3 px-0">
                <b-row>
                  <b-col cols="12">
                    <b-form-group label-cols="12" :label="$helpers.requiredlabel(
                      requirement_bookerinitial,
                      'Client SL A/C'
                    )
                      " :class="$helpers
                        .requiredlabel(
                          requirement_bookerinitial,
                          'Client SL A/C'
                        )
                        .slice(0, 1) == '*'
                        ? 'text-danger'
                        : ''
                        " label-size="sm">
                      <treeselect placeholder="Select slac..." searchPromptText="Type at least 3 chars..."
                        v-model="item.slac" :clearable="true" :async="true" :load-options="treeselect_loadSLAC"
                        :show-count="true" :flatten-search-results="true" :disable-branch-nodes="true"
                        :matchKeys="['id']" search-nested :disabled="false" :multiple="true">
                        <div slot="value-label" slot-scope="{ node }">
                          {{ node.raw.id }}
                        </div>
                      </treeselect>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label-cols="12" :label="$helpers.requiredlabel(
                      requirement_bookerinitial,
                      'Initials'
                    )
                      " :class="$helpers
                        .requiredlabel(
                          requirement_bookerinitial,
                          'Initials'
                        )
                        .slice(0, 1) == '*'
                        ? 'text-danger'
                        : ''
                        " label-size="sm">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.initials" placeholder="Enter initials" size="sm"
                          trim></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.initials = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Surname" label-for="surname" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.surname" placeholder="Enter surname"
                          size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.surname = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="First Name" label-for="firstname" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.firstname" placeholder="Enter first name"
                          size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.firstname = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Title" label-for="title" label-cols="12" label-size="sm">
                      <treeselect v-model="item.title" :clearable="true" :options="options_title" :disabled="false">
                      </treeselect>

                    </b-form-group>
                  </b-col>
                  <!-- <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group
                      label="Name"
                      label-for="description"
                      label-cols="12"
                    >
                      <b-input-group>
                        <b-form-input
                          type="text"
                          v-model="item.description"
                          placeholder="Enter name"
                          size="sm"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-button
                            size="sm"
                            variant="outline-secondary"
                            @click="item.description = ''"
                          >
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col> -->
                </b-row>
              </p>
            </b-tab>
            <b-tab v-if="idselected">
              <template #title>
                <i class="fa fa-history text-primary mr-1"></i> Audit
              </template>
              <p class="py-3 px-0">
                <b-row>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Created At" label-for="created_at" label-cols="12">
                      <b-input-group>
                        <b-input-group-prepend>
                          <b-form-datepicker size="sm" v-model="item.created_at" button-only label-help=""
                            locale="en-GB" :disabled="true"></b-form-datepicker>
                        </b-input-group-prepend>
                        <b-form-input size="sm" id="date" v-model="item.created_at" type="text" placeholder="YYYY-MM-DD"
                          autocomplete="off" :disabled="true"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.created_at = null"
                            :disabled="true">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Created By" label-for="created_by" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.created_by" placeholder="" size="sm"
                          :disabled="true"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.created_by = ''"
                            :disabled="true">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Updated At" label-for="updated_at" label-cols="12">
                      <b-input-group>
                        <b-input-group-prepend>
                          <b-form-datepicker size="sm" v-model="item.updated_at" button-only label-help=""
                            locale="en-GB" :disabled="true"></b-form-datepicker>
                        </b-input-group-prepend>
                        <b-form-input size="sm" id="date" v-model="item.updated_at" type="text" placeholder="YYYY-MM-DD"
                          autocomplete="off" :disabled="true"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.updated_at = null"
                            :disabled="true">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Updated By" label-for="updated_by" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.updated_by" placeholder="" size="sm"
                          :disabled="true"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.updated_by = ''"
                            :disabled="true">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>
              </p>
            </b-tab></b-tabs>
        </b-card-body>
        <b-card-footer class="nopadding mt-2">
          <b-row no-gutters>
            <b-col cols="auto" class="text-left mr-3">
              <b-button squared size="sm" variant="primary" @click="saveit"
                v-if="user.permissions.includes('setup_bookerinitials.admin')">
                <i class="fa fa-check"></i>
                Save It
              </b-button>
            </b-col>
            <b-col class="text-left my-auto">
              <div v-if="busy">
                <i class="fa fa-spinner fa-spin text-primary"></i>
              </div>
              <div v-else>
                <span v-html="message"></span>
              </div>
            </b-col>
            <b-col class="text-right" cols="8">
              <b-button squared size="sm" variant="secondary" class="mr-1" @click="discard">
                <i class="fa fa-chevron-left pr-1"></i>
                Back
              </b-button>
            </b-col>
          </b-row>
        </b-card-footer>

      </div>
    </b-card>
  </b-overlay>
</template>

<script>
import { mapGetters } from "vuex";
import gql from "graphql-tag";

import moment from "moment";

export default {
  name: "BookerInitialEdit",
  data() {
    return {
      busy: false,
      requirement_bookerinitial: {
        slac: "Client SL A/C",
        initials: "Initials"
      },
      options_title: [
        { id: "Mr", label: "Mr" },
        { id: "Mrs", label: "Mrs" },
        { id: "Ms", label: "Ms" },
        { id: "Miss", label: "Miss" },
        { id: "Dr", label: "Dr" },
      ],
      item: {
        id: null,
        initials: null,
        title: null,
        firstname: null,
        surname: null,
        slac: [],
        notes: null,
      },
      options: {
        title: "Booker Initials",
        icon: "fa fa-list",
      },
    };
  },
  watch: {
    selection() {
      this.load();
    },
  },
  methods: {
    async load() {
      let variables = {
        id: this.selection[0].id,
        dateformat: "YYYY-MM-DD",
      };
      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
            query setup_bookerinitials($id: String) {
              setup_bookerinitials(id: $id) {
                id
                slac
                initials
                firstname
                surname
                title
                notes
                created_at
                created_by
                updated_at
                updated_by
              }
            }
          `,
          variables,
        });

        if (response.data.setup_bookerinitials.length > 0) {
          this.item = response.data.setup_bookerinitials[0];

          this.item.slac = this.item.slac ? this.item.slac.split(",") : [];
        }
      } catch (error) {
        console.log(error);
      }
      this.busy = false;
    },
    async saveit() {

      let requirement = { ...this.requirement_bookerinitial };

      console.log(requirement);

      let requirements = "";
      for (var prop in requirement) {
        if (this.item[prop] == null) {
          requirements += requirement[prop] + ", ";
          // break;
        }
      }
      if (requirements.length > 0) {
        this.message =
          "<span class='text-danger'>" +
          requirements.slice(0, -1) +
          " required field(s). </span>";
        return;
      }
      this.busy = true;

      this.item.slac =
        this.item.slac.length > 0 ? this.item.slac.join(",") : null;

      let variables = { rows: [this.cleanit(this.item)] };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation setup_bookerinitials_save(
              $rows: [setup_bookerinitials_input]
              $dateformat: String
            ) {
              setup_bookerinitials_save(rows: $rows, dateformat: $dateformat) {
                id
                slac
                initials
                title
                firstname
                surname
                notes
              }
            }
          `,
          variables,
        });
        console.log(response);
        this.message = "<span class='text-primary'>Saved it.</span>";
      } catch (error) {
        this.message = "<span class='text-danger'>" + error.message + "</span>";
      }

      this.busy = false;
    },

    required(e) {

      this.requirement = {
        slac: "Client SL A/C",
        initials: "Initials"
      };
    },
  },
};
</script>

<style></style>